import React, { useState, useEffect } from 'react'
import { Row, Col } from 'antd'
import { useTranslation } from 'react-i18next'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import { draftjsCustomToolbarConfigs } from '../shared/draftjsCustomToolbarConfigs'
import { ErrorMessage } from 'formik'
import { convertToRaw, EditorState } from 'draft-js'
import Review from './Review'
import { initEditorState } from '../utils'

interface Props {
  field: any
  form: any
}

const CustomerReviews = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { field, form } = props
  const [reviews, setReviews] = useState(field.value?.content?.reviews || [])
  const [mainTitleEditor, setMainTitleEditor] = useState(
    initEditorState(field.value.title)
  )

  useEffect(() => {
    form.setFieldValue(field.name, {
      ...field.value,
      content: { reviews: reviews },
    })
  }, [reviews])

  const addReview = () => setReviews([...reviews, {}])

  return (
    <>
      <h2>{t('ficheComparative.customerReviews.title')}</h2>
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>
                {t('ficheComparative.customerReviews.sectionTitle')}
              </label>
            </Col>
            <Col span={24}>
              <Editor
                editorState={mainTitleEditor}
                editorClassName="custom-editor"
                localization={{
                  locale: 'fr',
                }}
                onEditorStateChange={(editorState: EditorState) => {
                  setMainTitleEditor(editorState)
                }}
                toolbar={draftjsCustomToolbarConfigs().sectionTitleToolbar}
                onBlur={() =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    title: draftToHtml(
                      convertToRaw(mainTitleEditor.getCurrentContent())
                    ),
                  })
                }
              />
              <ErrorMessage
                name={`title`}
                component="div"
                className="field-error"
              />
            </Col>
          </Row>
        </Col>
      </Row>

      {reviews.map((review: any, index: number) => {
        return (
          <Review
            key={`reviews.${index}.${review.name}`}
            setReviews={setReviews}
            reviews={reviews}
            index={index}
          />
        )
      })}
      <Row>
        <Col span={2}>
          <button
            type="button"
            onClick={() => {
              addReview()
            }}
          >
            {t('ficheComparative.customerReviews.addReview')}
          </button>
        </Col>
      </Row>
    </>
  )
}

export default CustomerReviews
